import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { Box, Breadcrumbs, Container, Divider, Typography } from '@availity/element';

import CommonStore from '../../stores/CommonStore';
import DynamicField from '../DynamicField';

const Header = ({ commonStore }) => {
  const { brand, appName } = commonStore;
  const { spaceId, name, state, code, type, logoURL } = brand;

  return state?.value && code && type ? (
    <DynamicField fieldName="publicHeader">
      <Box>
        <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2 }}>
          <Typography variant="h1" sx={{ fontSize: '2rem', fontWeight: 'bold' }}>
            {appName || ''}
          </Typography>
          <Box component="img" src={logoURL} alt="appLogo" sx={{ height: 48, ml: 2 }} />
        </Container>
      </Box>
    </DynamicField>
  ) : (
    <DynamicField fieldName="availityHeader">
      <Box sx={{ marginTop: '1rem' }}>
        <Breadcrumbs
          id="header-breadcrumbs"
          sx={{ marginBottom: '32px' }}
          active={appName}
          LinkProps={{ loadApp: false }}
          crumbs={[{ name, url: `/web/spaces/spaces/#/${spaceId}`, target: '_self' }]}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
          <Typography
            id="header-app-name"
            variant="h1"
            sx={{
              fontSize: '1.75rem',
              fontWeight: 600,
            }}
          >
            {appName}
          </Typography>
          {logoURL && <img id="header-logo" src={logoURL} alt="Space images.logo" />}
        </Box>
        <Divider sx={{ marginBottom: '1rem' }} />
      </Box>
    </DynamicField>
  );
};

export default inject('commonStore')(observer(Header));

Header.propTypes = {
  commonStore: PropTypes.oneOf([CommonStore]),
};
